export { Carousel } from './carousel';
//# sourceMappingURL=index.js.map